export const titleGame = 'DECATHLON_JAPAN';
export const dateGame = '速報サイト';
